import * as React from "react";
import { FvcAnalysisSet, FvcSession } from "webportalclient";
import { DynamicResultsGroupHeading } from "../../Shared/ResultsGroupHeading";
import { NextGenParameterResult, NextGenPftResultParameters } from "./NextGenPftResultParameters";
import { ParameterType } from "../../../misc/api/ParameterTypes";

interface NextGenRepeatabilityTableProps {
    session: FvcSession;
    analysisSet: FvcAnalysisSet;
}

export const NextGenRepeatabilityTable = ({ session, analysisSet }: NextGenRepeatabilityTableProps) => {
    const repeatabilityInMl = (value: number | undefined, bestValue: number | undefined) => {
        const repeatabilityResult = repeatability(value, bestValue);

        return repeatabilityResult !== undefined && repeatabilityResult !== null ? repeatabilityResult * 1000 : null;
    }

    const repeatability = (value: number | undefined, bestValue: number | undefined) => {
        return bestValue !== undefined && bestValue !== null && value !== undefined && value !== null ? (value - bestValue) : null;
    }

    const percentageRepeatability = (value: number | undefined, bestValue: number | undefined) => {
        if (bestValue === 0) return 0;

        return bestValue !== undefined && bestValue !== null && value !== undefined && value !== null ? Math.round(100 - (value / bestValue * 100)) : null;
    }

    return (
        <>
            <DynamicResultsGroupHeading resultsCount={analysisSet.tests.length} title="Repeatability" />
            <NextGenPftResultParameters
                session={session}
                analysisSet={analysisSet}
            >
                <>
                    <NextGenParameterResult name="FVC (ml)" identifier={ParameterType.FvcAbsoluteRepeatability} value={(t) => repeatabilityInMl(t.fvc, analysisSet.bestFvc)} parameterAudience="SelectedRepeatabilityParameters" />
                    <NextGenParameterResult name="FVC/FVC Best" identifier={ParameterType.FvcFvcBest} value={(t) => percentageRepeatability(t.fvc, analysisSet.bestFvc)} parameterAudience="SelectedRepeatabilityParameters" />
                    <NextGenParameterResult name="FEV1 (ml)" identifier={ParameterType.Fev1AbsoluteRepeatability} value={(t) => repeatabilityInMl(t.fev1, analysisSet.bestFev1)} bestValue={() => null} predictedValue={() => null} parameterAudience="SelectedRepeatabilityParameters" />
                    <NextGenParameterResult name="FEV1/FEV1 Best" identifier={ParameterType.Fev1Fev1Best} value={(t) => percentageRepeatability(t.fev1, analysisSet.bestFev1)} parameterAudience="SelectedRepeatabilityParameters" />
                    <NextGenParameterResult name="PEF (L/min)" identifier={ParameterType.PefMinAbsoluteRepeatability} value={(t) => repeatability(t.pefMin, analysisSet.bestPefMin)} bestValue={() => null} predictedValue={() => null} parameterAudience="SelectedRepeatabilityParameters" />
                    <NextGenParameterResult name="PEF/PEF Best" identifier={ParameterType.PefPefBest} value={(t) => percentageRepeatability(t.pefMin, analysisSet.bestPefMin)} parameterAudience="SelectedRepeatabilityParameters" />
                </>
            </NextGenPftResultParameters>
        </>
    );
}
